import {
  Sort,
  UserSortInput,
  UserTableFragment,
} from '../../apollo/__generated__/graphql.ts';
import { ISortObj } from '../table/table-utils.ts';

type IUserSortKeys = keyof UserSortInput;

export const usersSortKeys: IUserSortKeys[] = [
  'authProvider',
  'createdAt',
  'email',
  'graduationYear',
  'name',
  'parentEmail',
  'roles',
  'schoolName',
  'id',
];

export const usersDefaultSort: ISortObj = {
  createdAt: Sort.Desc,
  authProvider: undefined,
  email: undefined,
  graduationYear: undefined,
  id: undefined,
  name: undefined,
  parentEmail: undefined,
  roles: undefined,
  schoolName: undefined,
};

type IColumn = {
  title: string;
  key: keyof UserTableFragment | '_checkbox';
};
export const usersColumns: IColumn[] = [
  { key: 'name', title: 'Name' },
  { key: 'roles', title: 'Role' },
  { key: 'email', title: 'Email' },
  { key: 'schoolName', title: 'School' },
  { key: 'graduationYear', title: 'Grad. Year' },
  { key: 'parentEmail', title: 'Parent Email' },
  { key: 'authProvider', title: 'Auth Prov.' },
  { key: 'createdAt', title: 'Registered At' },
  { key: 'id', title: 'Id' },
];

export const usersColumnsModal: IColumn[] = [
  { key: '_checkbox', title: '' },
  ...usersColumns,
];
